import { RippleGlobalOptions } from '@angular/material/core';

export const matGlobalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};
